export enum UseBusEvents {
  NEW_MESSAGE_RECEIVED = 'NEW_MESSAGE_RECEIVED',
}
